import { render } from "./Maineditor.vue?vue&type=template&id=382edb0e"
import script from "./Maineditor.vue?vue&type=script&lang=js"
export * from "./Maineditor.vue?vue&type=script&lang=js"

import "./Maineditor.vue?vue&type=style&index=0&id=382edb0e&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__